import { render } from "./DashboardOrders.vue?vue&type=template&id=451f4693"
import script from "./DashboardOrders.vue?vue&type=script&lang=js"
export * from "./DashboardOrders.vue?vue&type=script&lang=js"

import exportComponent from "/vue-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__